import { call } from "redux-saga/effects";

import { backOfficeApiService } from "../../../../actionService/apiService";

import endPoints from "./wishElement.endpoints";

import {
  AddRateIntoCalculationRequestDto,
  ChangeWishCalculationVehicleRequestDto,
  CreateByRateRequestDto,
  CreateEmptyRequestDto,
  RemoveRateFromCalculationRequestDto,
  UpdateRateRequestDto,
} from "./wishElement.requestsDto";

import { ApiCallResult } from "../../../../types";
import type { WishElementDto } from "../../../../../dto/Applications/ApplicationDto";

const backOfficeWishElementApi = {
  createByRate: function* (dto: CreateByRateRequestDto) {
    return (yield call(
      [backOfficeApiService, backOfficeApiService.Post],
      endPoints.byRate,
      dto,
      dto.rateId,
    )) as ApiCallResult<WishElementDto>;
  },
  delete: function* (id: number) {
    return (yield call([backOfficeApiService, backOfficeApiService.Delete], endPoints.controller, id)) as ApiCallResult;
  },
  createEmpty: function* (dto: CreateEmptyRequestDto) {
    return (yield call([backOfficeApiService, backOfficeApiService.Post], endPoints.controller, {
      ...dto,
    })) as ApiCallResult<WishElementDto>;
  },
  changeCalculationVehicle: function* (dto: ChangeWishCalculationVehicleRequestDto) {
    return (yield call([backOfficeApiService, backOfficeApiService.Put], endPoints.calculationVehicle(dto), undefined, {
      calculationVehicleId: dto.calculationVehicleId,
    })) as ApiCallResult;
  },
  addRateInCalculation: function* (dto: AddRateIntoCalculationRequestDto) {
    return (yield call([backOfficeApiService, backOfficeApiService.Post], endPoints.addRateInCalculation(dto), {})) as ApiCallResult;
  },
  removeRateFromCalculation: function* (dto: RemoveRateFromCalculationRequestDto) {
    return (yield call([backOfficeApiService, backOfficeApiService.Post], endPoints.removeRateFromCalculation(dto), {})) as ApiCallResult;
  },
  clearWishList: function* (id: number) {
    return (yield call([backOfficeApiService, backOfficeApiService.Delete], endPoints.byCalculationVehicle, id)) as ApiCallResult;
  },
  updateRate: function* (dto: UpdateRateRequestDto) {
    return (yield call([backOfficeApiService, backOfficeApiService.Post], endPoints.updateRate(dto), dto)) as ApiCallResult<WishElementDto>;
  },
};

export default backOfficeWishElementApi;
